// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"495":"2c8949c5","755":"635d14c8"}[chunkId] + ".css";
};